import { inject, injectable } from 'inversify';

@injectable()
export class AppStateService {
    private loadCount: number = 0;

    public get IsLoading(): boolean {
        return this.loadCount > 0;
    }

    public StartLoad() {
        this.loadCount++;
    }

    public EndLoad() {
        this.loadCount--;
    }
}